import Vue from 'vue'
import App from './App'
import router from './router'

import 'babel-polyfill';
// import 'styles/reset.css';
import 'styles/animate.css';
import store from '@/store' // 此路径根据实际bridge.js路径填写
import VueCookies from 'vue-cookies'
import Ripple from 'vue-ripple-directive'
Vue.use(VueCookies)
Ripple.color = 'rgba(255, 255, 255, 0.35)';
Ripple.zIndex = 55;
Vue.directive('ripple', Ripple);
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
console.log(1111)

// import {
//   Menu, Submenu, Icon, MenuItem, Header, Form, FormItem, Input, Checkbox,
//   Button, Notice, Spin, Message, Breadcrumb,
//   BreadcrumbItem, Tabs, TabPane, Table, Alert, Row, Col, Card, Divider,
//   Timeline,TimelineItem,Modal,Steps,Upload,Tooltip,OptionGroup,Option
// } from 'view-design';
//
// Vue.component('Menu', Menu);
// Vue.component('Submenu', Submenu);
// Vue.component('Icon', Icon);
// Vue.component('MenuItem', MenuItem);
// Vue.component('Header', Header);
// Vue.component('Form', Form);
// Vue.component('FormItem', FormItem);
// Vue.component('Input', Input);
// Vue.component('Checkbox', Checkbox);
// Vue.component('Button', Button);
// Vue.component('Notice', Notice);
// Vue.component('Spin', Spin);
// Vue.component('Message', Message);
// Vue.component('Breadcrumb', Breadcrumb);
// Vue.component('BreadcrumbItem', BreadcrumbItem);
// Vue.component('Tabs', Tabs);
// Vue.component('TabPane', TabPane);
// Vue.component('Table', Table);
// Vue.component('Alert', Alert);
// Vue.component('Card', Card);
// Vue.component('Row', Row);
// Vue.component('Col', Col);
// Vue.component('Divider', Divider);
// Vue.component('Timeline', Timeline);
// Vue.component('TimelineItem', TimelineItem);
// Vue.component('Modal', Modal);
// Vue.component('Steps', Steps);
// Vue.component('Step', Steps.Step);
// Vue.component('Upload', Upload);
// Vue.component('Tooltip', Tooltip);
// // Vue.component('Select', Select);
// Vue.component('OptionGroup', OptionGroup);
// Vue.component('Option', Option);
import ViewUI,{Modal,Message,Notice} from 'view-design';
Vue.use(ViewUI);
Vue.prototype.$Modal = Modal
Vue.prototype.$Message = Message
Vue.prototype.$Notice = Notice
//     ,["import", {
//     "libraryName": "view-design",
//     "libraryDirectory": "src/components"
// }]
import axios from "axios";
Vue.prototype.$axios = axios
// Vue.prototype.$baseUrl = process.env.baseUrl
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach(() => {
  // finish progress bar
  Modal.remove()
})

Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js